// extracted by mini-css-extract-plugin
export default {"anchor":"anchor_anchor__yQ0tH"};